import React from "react";
import { EvtHeader } from "components/header";

import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import DepartmentScatterChart from "./components/scatter-chart";
import DepartmentAcknowledgeBarChart from "./components/department-acknowledge-barchart";
import LoggedVsApprovedScatter from "./components/logged-vs-approved-scatter";
import LoggedVsPayrollDifferenceChart from "./components/logged-vs-payroll-difference-chart";
import {
  fetchDepartmentTimesheetChart,

} from "./api";
import { getItemsFromCollection } from "directus/src/operations";
import { useQuery } from "@tanstack/react-query";
import HeaderPortal from "components/portal/header-portal";
import TimesheetAnalyticsFilters from "./filters";
import { usePersistentState } from "@/hooks/use-persistent-state";
import { Tabs, TabsList, TabsTrigger } from "ui/components/tabs";
import DepartmentList from "./components/department-list";

const TimesheetDepartmentDashboard = () => {
  const [view, setView] = React.useState("graph");
  const [state, setState] = usePersistentState({
    endpoint: "timesheet-department-dashboard",
    defaultState: {
      dateRange: {
        from: CURRENT_MONTH_START_DATE,
        to: CURRENT_MONTH_END_DATE,
      },
    },
  });

  const filters = {
    startDate: state?.dateRange?.from,
    endDate: state?.dateRange?.to,
  };

  const setFilters = (next) =>
    setState({
      dateRange: {
        from: next?.startDate,
        ...(next?.endDate ? { to: next.endDate } : {}),
      },
    });



  const { data, isLoading, isError, error } = useQuery({
    queryKey: [
      "timesheet-department-chart",
      {
        startDate: filters.startDate,
        endDate: filters.endDate,
      },
    ],
    queryFn: () => fetchDepartmentTimesheetChart(filters),
    enabled: view === "graph",
  });

  const [listData, setListData] = React.useState([]);
  const [orgDataState, setOrgDataState] = React.useState(null);
  const [listLoading, setListLoading] = React.useState(false);

  React.useEffect(() => {
    if (data) {
      setListData(data.departmentData || []);
      setOrgDataState(data.orgData || null);
    }
  }, [data]);

  React.useEffect(() => {
    if (view === "list") {
      setListLoading(true);
    }
  }, [view, filters.startDate, filters.endDate]);

  const handleSetListData = (val) => {
    setListData(val);
    setListLoading(false);
  };

  return (
    <div className="p-2 flex-1 overflow-auto">
      <EvtHeader title="Timesheet Analytics">
        <Tabs value={view} onValueChange={setView}>
          <TabsList className="bg-muted">
            <TabsTrigger value="graph" className="cursor-pointer">Graph</TabsTrigger>
            <TabsTrigger value="list" className="cursor-pointer">List</TabsTrigger>
          </TabsList>
        </Tabs>
      </EvtHeader>
      <HeaderPortal>
        <TimesheetAnalyticsFilters filters={filters} setFilters={setFilters} />
      </HeaderPortal>
      <div className="mt-6 px-4 lg:px-6">
        <>
          {view === "graph" ? (
            <DepartmentScatterChart
              departmentData={listData}
              orgData={orgDataState}
              loading={isLoading}
              isError={isError}
              error={error}
            />
          ) : (
            <DepartmentList
              filters={filters}
              setListData={handleSetListData}
              setOrgData={setOrgDataState}
            />
          )}
          <div className="mt-8">
            <LoggedVsPayrollDifferenceChart
              data={listData}
              loading={view === "graph" ? isLoading : listLoading}
              isError={view === "graph" ? isError : false}
              error={view === "graph" ? error : null}
            />
          </div>
          <div className="mt-8">
            <LoggedVsApprovedScatter
              data={listData}
              loading={view === "graph" ? isLoading : listLoading}
              isError={view === "graph" ? isError : false}
              error={view === "graph" ? error : null}
            />
          </div>
        </>
      </div>
    </div>
  );
};

export default TimesheetDepartmentDashboard;
